import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-status-cell-renderer',
  standalone: true,
  imports: [TagModule],
  template: ` <p-tag [severity]="severity" [value]="label" styleClass="compact-tag"></p-tag> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        height: 100%;
      }

      :host ::ng-deep .compact-tag {
        display: inline-flex !important;
        font-size: 0.8rem;
        padding: 0.25rem 0.5rem;
        line-height: 1;
        height: auto !important;
        min-height: unset !important;
      }

      :host ::ng-deep .compact-tag .p-tag-value {
        line-height: 1;
      }
    `,
  ],
})
export class StatusCellRendererComponent implements ICellRendererAngularComp {
  label: string = '';
  severity: 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined = 'info';

  agInit(params: ICellRendererParams): void {
    const state = params.value;
    const stateConfig = this.getStateConfig(state);
    this.label = stateConfig.label;
    this.severity = stateConfig.severity as
      'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined;
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  private getStateConfig(state: string): { label: string; severity: string } {
    const stateConfigs: { [key: string]: { label: string; severity: string } } = {
      Created: { label: 'Selecting Candidates', severity: 'info' },
      Review: { label: 'In Review', severity: 'warn' },
      IssuingCertificates: { label: 'Ready to Issue Certificates', severity: 'info' },
      FinalReview: { label: 'Final Review', severity: 'warn' },
      Completed: { label: 'Finalized', severity: 'success' },
      Cancelled: { label: 'Cancelled', severity: 'danger' },
    };

    return stateConfigs[state] || { label: state, severity: 'secondary' };
  }
}
